"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactRelativePortal = _interopRequireDefault(require("react-relative-portal"));

var _model = require("./model");

var _constants = require("../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  left: ", "px;\n  top: -50%;\n  width: 100%;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  left: ", "px;\n  width: ", "px;\n  top: -10px;\n  cursor: default;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var roomIcon = /*#__PURE__*/_react.default.createElement("svg", {
  className: "icon icon-sl",
  dangerouslySetInnerHTML: {
    __html: '<use xlink:href="img/sprite.svg#icon-discord"></use>'
  }
});

var camIcon = /*#__PURE__*/_react.default.createElement("svg", {
  className: "icon icon-cam",
  dangerouslySetInnerHTML: {
    __html: '<use xlink:href="img/sprite.svg#icon-cam"></use>'
  }
});

var EventContainer = _styledComponents.default.div(_templateObject(), function (_ref) {
  var position = _ref.position;
  return position;
}, function (_ref2) {
  var width = _ref2.width;
  return width;
});

var TrackContent = _styledComponents.default.div(_templateObject2(), function (_ref3) {
  var adjust = _ref3.adjust;
  return adjust;
});

var ePic = function ePic(pic) {
  if (!pic) {
    return null;
  }

  var imgSrc = ''; // ems data has avatar as a string instead of object (user.avatar db field)

  if (typeof pic === 'string') {
    imgSrc = pic;
  } else {
    var picId = pic.url.split('/').reverse()[0];
    imgSrc = "https://media.graphassets.com/resize=fit:crop,height:100,width:100/output=format:webp/".concat(picId);
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "time-track__pic"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: imgSrc
  }));
};

var eTitle = function eTitle(speaker, title) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "time-track__speaker"
  }, getTitleStr(speaker, title));
};

var getTitleStr = function getTitleStr(speaker, title) {
  return speaker ? "".concat(speaker, " \xAB\u200E").concat(title, "\xBB") : title;
};

var iSpeaker = function iSpeaker(name, place, title, text) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", {
    className: "track-tooltip__speaker"
  }, name, ", ", place), /*#__PURE__*/_react.default.createElement("p", {
    className: "track-tooltip__title"
  }, "\xAB\u200E", title, "\xBB"), /*#__PURE__*/_react.default.createElement("div", {
    className: "track-tooltip__desc",
    dangerouslySetInnerHTML: {
      __html: text
    }
  }));
};

var iEmsTalk = function iEmsTalk(speakers, title, shortDescription) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", {
    className: "track-tooltip__speaker"
  }, speakers ? speakers.map(function (_ref4, i) {
    var name = _ref4.name,
        location = _ref4.location;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: i
    }, name, ", ", location, i !== speakers.length - 1 ? '; ' : '');
  }) : null), /*#__PURE__*/_react.default.createElement("p", {
    className: "track-tooltip__title"
  }, "\xAB\u200E", title, "\xBB"), shortDescription ? /*#__PURE__*/_react.default.createElement("div", {
    className: "track-tooltip__desc"
  }, shortDescription) : null);
};

var iLt = function iLt(title, lightningTalks) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", {
    className: "track-tooltip__speaker"
  }, title), (lightningTalks || []).map(function (lt, i) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "track-tooltip__sec",
      key: i
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "track-tooltip__title"
    }, lt.title, " - ", lt.name), /*#__PURE__*/_react.default.createElement("div", {
      className: "track-tooltip__desc",
      dangerouslySetInnerHTML: {
        __html: lt.text
      }
    }));
  }));
};

var DiscussionRoomTooltipContent = function DiscussionRoomTooltipContent(_ref5) {
  var text = _ref5.text,
      title = _ref5.title,
      speakers = _ref5.speakers;

  if (text) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "time-track__discussion-link",
      dangerouslySetInnerHTML: {
        __html: text
      }
    });
  }

  return /*#__PURE__*/_react.default.createElement("div", null, speakers === null || speakers === void 0 ? void 0 : speakers.map(function (info) {
    return /*#__PURE__*/_react.default.createElement("p", {
      key: info.name
    }, /*#__PURE__*/_react.default.createElement("strong", null, info.name), info.company ? " (".concat(info.company, ")") : null);
  }));
};

var Tooltip = function Tooltip(_ref6) {
  var children = _ref6.children,
      on = _ref6.on;
  return on ? /*#__PURE__*/_react.default.createElement("div", null, children) : null;
};

var Talk = function Talk(_ref7) {
  var talk = _ref7.talk,
      onClick = _ref7.onClick,
      isOrgEvent = _ref7.isOrgEvent;
  var avatar = talk.avatar,
      speaker = talk.speaker,
      title = talk.title,
      lightningTalks = talk.lightningTalks,
      text = talk.text,
      name = talk.name,
      place = talk.place,
      description = talk.description,
      speakers = talk.speakers,
      shortDescription = talk.shortDescription,
      icon = talk.icon;
  var mainSpeaker = speakers && speakers.length > 0 ? speakers[0].name : speaker;

  var handleClick = function handleClick() {
    onClick({
      date: '',
      track: '',
      speaker: mainSpeaker
    });
  };

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isVisible = _useState2[0],
      toggleIsVisible = _useState2[1];

  var isOrgTooltipExists = isOrgEvent && !!description;
  var isEmsTalkTooltipExists = speakers && speakers.length > 0 || shortDescription;
  var isAsLeastOneTooltipExists = name || lightningTalks || isOrgTooltipExists || isEmsTalkTooltipExists;
  var changePortalVisibility = (0, _react.useCallback)(function (boolean) {
    var _window;

    if (window && ((_window = window) === null || _window === void 0 ? void 0 : _window.innerWidth) > _constants.TABLET_WIDTH) {
      toggleIsVisible(boolean);
    }
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "time-track__item js-time",
    onClick: handleClick,
    title: !name && !lightningTalks ? getTitleStr(mainSpeaker, title) : '',
    style: {
      '--bgColor': talk.bgColor,
      width: '100%',
      cursor: 'pointer'
    },
    onMouseEnter: function onMouseEnter() {
      return changePortalVisibility(true);
    },
    onMouseLeave: function onMouseLeave() {
      return changePortalVisibility(false);
    }
  }, /*#__PURE__*/_react.default.createElement(_reactRelativePortal.default, {
    left: 0,
    top: 20
  }, isVisible && isAsLeastOneTooltipExists && /*#__PURE__*/_react.default.createElement("div", {
    className: "track-tooltip",
    style: {
      position: 'sticky',
      '--bgColor': talk.bgColor
    }
  }, /*#__PURE__*/_react.default.createElement(Tooltip, {
    on: isEmsTalkTooltipExists
  }, iEmsTalk(speakers, title, shortDescription)), /*#__PURE__*/_react.default.createElement(Tooltip, {
    on: !!name
  }, iSpeaker(name, place, title, text)), /*#__PURE__*/_react.default.createElement(Tooltip, {
    on: !!lightningTalks
  }, iLt(title, lightningTalks)), /*#__PURE__*/_react.default.createElement(Tooltip, {
    on: isOrgTooltipExists
  }, /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: description
    }
  })))), icon ? ePic(icon) : ePic(avatar), eTitle(mainSpeaker, title));
};

var QARoom = function QARoom(_ref8) {
  var talk = _ref8.talk,
      onClick = _ref8.onClick;

  var handleClick = function handleClick() {
    onClick({
      date: '',
      track: '',
      isQaEvent: true
    });
  };

  return /*#__PURE__*/_react.default.createElement("a", {
    onClick: handleClick,
    className: "time-track__link js-time",
    style: {
      '--bgColor': talk.bgColor,
      width: '100%'
    }
  }, "Q&A ", roomIcon);
};

var SpeakerRoom = function SpeakerRoom(_ref9) {
  var talk = _ref9.talk,
      onClick = _ref9.onClick;
  var speakers = talk.speakers,
      title = talk.title,
      roomLink = talk.roomLink,
      type = talk.type,
      icon = talk.icon,
      link = talk.link;

  var handleClick = function handleClick() {
    var _ref10;

    var samePage = false;

    if (((_ref10 = link || roomLink) === null || _ref10 === void 0 ? void 0 : _ref10[0]) === '#') {
      samePage = true;
    }

    var override = {};

    if (type === 'expo-room') {
      // TODO: passing empty data and track will make speakers room available during the whole event
      override = {
        date: '',
        track: '',
        time: '',
        duration: ''
      };
    }

    onClick(_objectSpread(_objectSpread({}, override), {}, {
      samePage: samePage
    }));
  };

  return /*#__PURE__*/_react.default.createElement("a", {
    onClick: handleClick,
    className: "time-track__link room js-time",
    style: {
      '--bgColor': talk.bgColor,
      width: '100%'
    }
  }, icon ? ePic(icon) : speakers && ePic(speakers[0].avatar), eTitle('', title));
};

var DiscussionRoom = function DiscussionRoom(_ref11) {
  var talk = _ref11.talk,
      onClick = _ref11.onClick;
  var pic = talk.pic,
      speakers = talk.speakers,
      title = talk.title,
      text = talk.text,
      icon = talk.icon;

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isVisible = _useState4[0],
      toggleIsVisible = _useState4[1];

  var changePortalVisibility = (0, _react.useCallback)(function (boolean) {
    var _window2;

    if (window && ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.innerWidth) > _constants.TABLET_WIDTH) {
      toggleIsVisible(boolean);
    }
  }, []);
  return /*#__PURE__*/_react.default.createElement("a", {
    onClick: onClick,
    className: "time-track__item time-track__link discussion js-time",
    style: {
      '--bgColor': talk.bgColor,
      width: '100%'
    },
    onMouseEnter: function onMouseEnter() {
      return changePortalVisibility(true);
    },
    onMouseLeave: function onMouseLeave() {
      return changePortalVisibility(false);
    }
  }, /*#__PURE__*/_react.default.createElement(_reactRelativePortal.default, {
    left: 0,
    top: 20
  }, isVisible && title && /*#__PURE__*/_react.default.createElement("div", {
    className: "track-tooltip",
    style: {
      position: 'sticky',
      '--bgColor': talk.bgColor
    }
  }, /*#__PURE__*/_react.default.createElement(Tooltip, {
    on: !!title
  }, /*#__PURE__*/_react.default.createElement(DiscussionRoomTooltipContent, {
    text: text,
    title: title,
    speakers: speakers
  })))), icon ? ePic(icon) : ePic(pic), eTitle('', title), camIcon);
};

var TrackEvent = function TrackEvent(_ref12) {
  var event = _ref12.event,
      calcPosition = _ref12.calcPosition,
      onClick = _ref12.onClick,
      trackTitle = _ref12.trackTitle;
  var position = calcPosition(event);
  var width = (0, _model.calcWidth)(event.duration);

  var handleClick = function handleClick(info) {
    onClick(_objectSpread(_objectSpread(_objectSpread({}, event), info), {}, {
      trackTitle: trackTitle
    }));
  };

  if (event.eventType === 'QA') {
    return /*#__PURE__*/_react.default.createElement(EventContainer, {
      position: position,
      width: width
    }, /*#__PURE__*/_react.default.createElement(QARoom, {
      talk: event,
      onClick: handleClick
    }));
  }

  if (event.eventType === 'SpeakersRoom') {
    return /*#__PURE__*/_react.default.createElement(EventContainer, {
      position: position,
      width: width
    }, /*#__PURE__*/_react.default.createElement(SpeakerRoom, {
      talk: event,
      onClick: handleClick
    }));
  }

  if (event.eventType === 'PanelDiscussion' || event.eventType === 'DiscussionRoom') {
    return /*#__PURE__*/_react.default.createElement(EventContainer, {
      position: position,
      width: width
    }, /*#__PURE__*/_react.default.createElement(DiscussionRoom, {
      talk: event,
      onClick: handleClick
    }));
  }

  if (event.eventType === 'OrgEvent') {
    return /*#__PURE__*/_react.default.createElement(EventContainer, {
      position: position,
      width: width
    }, /*#__PURE__*/_react.default.createElement(Talk, {
      talk: event,
      onClick: handleClick,
      isOrgEvent: true
    }));
  }

  return /*#__PURE__*/_react.default.createElement(EventContainer, {
    position: position,
    width: width
  }, /*#__PURE__*/_react.default.createElement(Talk, {
    talk: event,
    onClick: handleClick
  }));
};

function Track(_ref13) {
  var track = _ref13.track,
      calcPosition = _ref13.calcPosition,
      onClick = _ref13.onClick;
  var list = track.list,
      title = track.title;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('time-track__track', {
      odd: track.odd
    }),
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'flex-start'
    }
  }, /*#__PURE__*/_react.default.createElement(TrackContent, {
    adjust: 26
  }, list.map(function (evt, i) {
    return /*#__PURE__*/_react.default.createElement(TrackEvent, {
      key: i,
      event: evt,
      trackTitle: title,
      calcPosition: calcPosition,
      onClick: onClick
    });
  })));
}

var _default = Track;
exports.default = _default;